// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__XBRVW","info":"PatientInfo_info__1yk3h"};